<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import SecondaryButton from "@/components/SecondaryButton.vue";
import MainForm from "@/components/MainForm.vue";
import FormTitle from "@/components/FormTitle.vue";
export default {
	components: {
		SecondaryButton,
		MainForm,
		FormTitle,
	},
	data() {
		return {
			listed: false,
			showForm: false,
			action: "Agregar",
			roles: [],
			role: {
				id: { name: "Id", value: null },
				title: { name: "Título", value: null },
				slug: { name: "Slug", value: null },
			},
		};
	},
	created() {
		this.listed = false;
		this.loadRoles();
	},
	computed: {
		...mapGetters({
			isLoading: "loading/isLoading",
			//READ_ROLES
			readRoles: "getRoles/readRoles",
			//READ_ERRORS
			getRolesError: "getRoles/readError",
			createError: "createRole/readError",
			updateError: "updateRole/readError",
			deleteError: "deleteRole/readError",
		}),
	},
	methods: {
		...mapMutations({
			setLoading: "loading/SET_LOADING",
			//SET_ROLES
			setCreateRole: "createRole/SET_ROLE",
			setUpdateRole: "updateRole/SET_ROLE",
			setDeleteId: "deleteRole/SET_ID",
			setUpdateId: "updateRole/SET_ID",
			//SET_ERRORS
			setGetError: "getRoles/SET_ERROR",
			setCreateError: "createRole/SET_ERROR",
			setUpdateError: "updateRole/SET_ERROR",
			setDeleteError: "deleteRole/SET_ERROR",
		}),
		...mapActions({
			getRoles: "getRoles/getRoles",
			createRole: "createRole/createRole",
			updateRole: "updateRole/updateRole",
			deleteRole: "deleteRole/deleteRole",
		}),
		getImage(image) {
			return `${require(`@/assets/images/views${this.$route.path.toUpperCase()}/${image}`)}`;
		},
		loadRoles() {
			this.clearErrors();
			this.getRoles()
				.then((result) => {
					if (result) {
						this.roles = this.readRoles;
					}
				})
				.finally(() => {
					this.listed = true;
				});
		},
		toggleForm() {
			this.clearErrors();
			this.showForm = !this.showForm;
		},
		update(data) {
			this.clearErrors();
			this.toggleForm();
			this.action = "Actualizar";
			for (let r in this.role) {
				this.role[r]["value"] = data[r];
			}
		},
		remove(role) {
			this.clearErrors();
			this.setLoading(true);

			this.$swal({
				title: "¿Desea eliminar este Rol?",
				icon: "warning",
				showCancelButton: true,
				cancelButtonText: "Cancelar",
				confirmButtonText: "Aceptar",
			}).then((result) => {
				if (result.isConfirmed) {
					this.setDeleteId(role.id.value || role.value);
					this.deleteRole().then((response) => {
						if (response) {
							this.loadRoles();
							this.$swal({
								icon: "success",
								title: `El Rol ${
									role.title.value || role.title
								} ha sido eliminado correctamente.`,
								showConfirmButton: false,
								timer: 3000,
							});
							this.clear();
							if (this.showForm) this.toggleForm();
						}
					});
				}
			});

			this.setLoading(false);
		},
		submit() {
			this.clearErrors();
			this.setLoading(true);
			let role = this.role;
			let output = {};

			for (let r in role) {
				output[r] = role[r].value;
			}

			if (this.action == "Agregar") {
				this.setCreateRole(output);
				this.createRole().then((result) => {
					if (result) {
						this.loadRoles();
						this.toggleForm();
						this.$swal({
							icon: "success",
							title: `El Rol ${output.title} ha sido creado con éxito.`,
							showConfirmButton: false,
							timer: 3000,
						});
						this.clear();
					}
				});
			} else {
				this.setUpdateId(output.id);
				this.setUpdateRole(output);

				this.updateRole().then((result) => {
					if (result) {
						this.loadRoles();
						this.toggleForm();
						this.$swal({
							icon: "success",
							title: `El Rol ${output.title} se actualizó con éxito.`,
							showConfirmButton: false,
							timer: 3000,
						});
						this.clear();
					}
				});
			}

			this.setLoading(false);
		},
		clear() {
			for (let r in this.role) {
				this.role[r].value = null;
			}
			this.action = "Agregar";
		},
		clearErrors() {
			this.setGetError(null);
			this.setCreateError(null);
			this.setDeleteError(null);
			this.setUpdateError(null);
		},
	},
};
</script>

<template>
	<div class="main">
		<div
			v-if="showForm"
			class="modal-form fixed right-0 top-0 p-3 md:p-5 w-full h-full z-30 overflow-y-auto"
		>
			<div
				class="content-wrap bg-white border-2 border-gray px-6 pt-10 pb-6 shadow-md absolute max-w-3xl mx-auto right-0 left-0"
			>
				<SecondaryButton
					@click.native="[toggleForm(), clear()]"
					text="x"
					buttonColor="bg-red"
					class="close rounded-full h-10 absolute right-6 top-6"
				/>
				<form-title
					:action="action"
					text="Roles de "
					textBold="Acceso"
					:name="role.title.value"
				></form-title>
				<!-- DISPLAY FORM -->
				<form class="grid grid-cols-2 gap-5 items-center">
					<label
						class="col-span-2 text-lg"
						:for="key"
						v-for="(r, key, index) in role"
						:key="key"
						v-show="key != 'id'"
						ref="labels"
					>
						<textarea
							:ref="index"
							:required="key != 'id'"
							class="w-full border border-gray h-full px-4 py-2 text-lg rounded-md bg-gray-light align-top"
							:name="key"
							:placeholder="r.name"
							v-model="r.value"
							rows="2"
							v-capitalizeInput
						/>
					</label>
					<span
						v-if="getRolesError"
						class="block mt-5 red text-center b col-span-2"
						>{{ getRolesError }}</span
					>
					<span
						v-if="deleteError"
						class="block mt-5 red text-center b col-span-2"
						>{{ deleteError }}</span
					>
					<span
						v-if="createError"
						class="block mt-5 red text-center b col-span-2"
						>{{ createError }}</span
					>
					<span
						v-if="updateError"
						class="block mt-5 red text-center b col-span-2"
						>{{ updateError }}</span
					>
					<div
						class="col-span-2 my-6 flex flex-col items-center md:flex-row justify-evenly"
					>
						<SecondaryButton
							v-if="action == 'Actualizar'"
							@click.native="remove(role)"
							text="Eliminar"
							buttonColor="bg-red"
							class="flex-none mb-3 md:mb-0 md:mr-2"
						/>
						<SecondaryButton
							@click.native="[toggleForm(), clear()]"
							v-else
							text="Cancelar"
							buttonColor="bg-red"
							class="flex-none mb-3 md:mb-0 md:mr-2"
						/>
						<SecondaryButton
							:text="action"
							@click.native="submit"
							class="flex-none"
						/>
					</div>
				</form>
			</div>
		</div>
		<main-form
			v-on:toggleForm="toggleForm"
			:action="action"
			text="Roles de"
			textBold="Acceso"
		></main-form>
		<table
			v-if="!isLoading && roles.length > 0"
			id="no-more-tables"
			class="block lg:table table-auto w-full"
		>
			<thead class="block lg:table-header-group elektra-bg-red">
				<tr class="block lg:table-row border border-gray">
					<th
						class="block text-white lg:table-cell b border-r border-gray py-3 px-1"
						v-for="(field, key) in role"
						:key="key"
						v-show="key != 'id'"
					>
						{{ field.name }}
					</th>
					<th
						class="block lg:table-cell b text-white border-r py-3 px-1"
					>
						Acciones
					</th>
				</tr>
			</thead>
			<tbody class="block md:flex flex-wrap lg:table-row-group">
				<tr
					class="block odd:bg-gray-light hover:bg-orange lg:table-row border-t border-b border-gray box-border"
					:class="
						roles.length > 1
							? 'w-full md:w-1/2 lg:w-full'
							: 'w-full'
					"
					v-for="(r, i) in roles"
					:key="i"
				>
					<td
						class="block before:text-center before:justify-center first:border-l lg:table-cell text-center border-r border-gray-light py-3 px-1"
						:class="{ 'green b': key == 'id' }"
						v-for="(field, key) in role"
						:key="key"
						v-show="key != 'id'"
					>
						{{ r[key] }}
					</td>
					<td
						class="flex justify-evenly px-1 items-center py-3 icons lg:table-cell"
					>
						<div class="w-full flex justify-evenly items-center">
							<span
								class="title-hint"
								aria-label="Da clic aquí para editar este Rol"
							>
								<font-awesome-icon
									@click="update(r)"
									class="green hover:text-white text-3xl md:text-2xl cursor-pointer"
									icon="fa-solid fa-pen-to-square"
								/>
							</span>
							<span
								class="title-hint"
								aria-label="Da clic aquí para eliminar este Rol"
							>
								<font-awesome-icon
									@click="remove(r)"
									class="red hover:text-white text-3xl md:text-2xl cursor-pointer"
									icon="fa-solid fa-trash-can"
								/>
							</span>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<span v-else-if="listed" class="block my-3 blue text-center b"
			>No se encontraron roles</span
		>
	</div>
</template>

<style lang="scss" scoped>
/*
	Label the data
	*/

@media (max-width: 1023px) {
	$fields: 1 "Título", 2 "Slug";

	@each $i, $field in $fields {
		#no-more-tables td:nth-child(#{$i + 1}):before {
			content: $field;
		}
	}
}
</style>
